<template>
    <p v-model="open">
        <slot></slot>
    </p>
</template>
<script>
    export default {
        computed: {
            open: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
        },
        props: ['value']
    };
</script>

<style scoped>
    p {
        color: red;
        font-size: 20;
        font-weight: bold;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>